import React from 'react';
import styled from 'styled-components';
import { dynamic } from 'src/helpers/dynamic';

import HotelMapLoader from 'src/components/YandexMap/components/HotelMapLoader';
import type { LazyYandexHotelMapProps } from './types';

const YandexHotelMap = dynamic(
  () => import(/* webpackChunkName: "YandexHotelMap" */ './YandexHotelMap'),
);

const LazyYandexHotelMap: React.FC<Readonly<LazyYandexHotelMapProps>> = (
  props,
) => {
  const [isMapLoading, setIsMapLoading] = React.useState(true);
  const { isMobile, height } = props;
  return (
    <HotelMapBackground isMobile={isMobile} height={height}>
      {isMapLoading && <HotelMapLoader />}
      <YandexHotelMap setIsMapLoading={setIsMapLoading} {...props} />
    </HotelMapBackground>
  );
};

const HotelMapBackground = styled.div<{ isMobile: boolean; height?: string }>`
  position: relative;
  height: ${({ isMobile, height }) => (isMobile ? height : '400px')};
`;

export default LazyYandexHotelMap;
